import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useCallback, useState, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';
const iconStyles = css `
  color: '#91ac4c';
`;
export const containerClassName = css `
  display: flex;
  align-items: center;
`;
export const labelClassName = css `
  ${theme.typeStyles.titleSmallStyles}
  margin-right: ${styleUtils.rem(8)};
`;
const defaultProps = {
    className: '',
    label: '',
    placement: 'right',
    triggerEvent: 'hover',
};
const InfoTooltip = ({ className, hintText, label, placement = defaultProps.placement, triggerEvent = defaultProps.triggerEvent, }) => {
    const [isTooltipVisible, setIsTooltipVisible,] = useState(false);
    const activateTooltip = useCallback(() => {
        setIsTooltipVisible(true);
    }, []);
    const deactivateTooltip = useCallback(() => {
        setIsTooltipVisible(false);
    }, []);
    const toggleTooltip = useCallback(() => {
        setIsTooltipVisible((isTooltipCurrentlyVisible) => (!isTooltipCurrentlyVisible));
    }, []);
    return (_jsxs("div", Object.assign({ className: className, css: containerClassName }, { children: [label && (_jsx("span", Object.assign({ css: labelClassName }, { children: label }))), _jsxs("div", Object.assign({ css: css `
            display: inline-flex;
            position: relative;
          `, onClick: triggerEvent === 'click' ? toggleTooltip : undefined, onKeyDown: triggerEvent === 'click' ? toggleTooltip : undefined, onMouseEnter: triggerEvent === 'hover' ? activateTooltip : undefined, onMouseLeave: triggerEvent === 'hover' ? deactivateTooltip : undefined }, { children: [_jsx("div", Object.assign({ css: iconStyles }, { children: _jsx(Icon, { type: "help" }) })), _jsx(Tooltip, Object.assign({ placement: placement, showArrow: true, showTooltip: isTooltipVisible }, { children: hintText }))] }))] })));
};
const MemoizedInfoTooltip = memo(InfoTooltip);
export { MemoizedInfoTooltip as InfoTooltip };
// MC-1068 Temporary hack for Storybook.
export default InfoTooltip;
